export const SSO_OKTA_ISSUER = process.env.REACT_APP_SSO_OKTA;
export const SSO_OKTA_CLIENT_ID = process.env.REACT_APP_SSO_OKTA_CLIENT_ID;
